import { render, staticRenderFns } from "./monthly.vue?vue&type=template&id=61cb0c15&scoped=true"
import script from "./monthly.vue?vue&type=script&lang=js"
export * from "./monthly.vue?vue&type=script&lang=js"
import style0 from "./monthly.vue?vue&type=style&index=0&id=61cb0c15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb0c15",
  null
  
)

export default component.exports